import { sapiPublisherOf } from '@cbs-mp/brands-config';

export const shouldShowBoostChat = publication =>
    CONFIG.myPage?.brandsWithBoostChat?.trim().split(',').indexOf(publication) > -1;

export const chatSubscriptionTypes = {
    NONE: 'none',
    DIGITAL: 'digital',
    PAPER: 'paper',
};

const monoPublishers = {
    bt: 'bti',
};

export const mapPublisherToMonoPublisher = publisher =>
    (monoPublishers[publisher] || sapiPublisherOf(publisher)).toUpperCase();

